import { mapServerToAccessoriesProduct } from './product-mappers/map-server-to-accessories-product.js';
import { mapServerToSunglassesProduct } from './product-mappers/map-server-to-sunglasses-product.js';

const mapGraphProductToClientProduct = (serverProduct, slug, locale)=>{
    switch(serverProduct.__typename){
        case 'SunglassesProduct':
            return mapServerToSunglassesProduct(serverProduct, slug, locale);
        case 'AccessoriesProduct':
            return mapServerToAccessoriesProduct(serverProduct, slug, locale);
        default:
            console.error(`Cannot map server product with typename: ${serverProduct.__typename} and slug: ${slug}`);
            return;
    }
};

export { mapGraphProductToClientProduct };
//# sourceMappingURL=map-to-client-product.js.map
